// Price block animation
(function () {
    const priceBlock = document.querySelector(`.price`);
    const nextBlock = document.querySelector(`.information`);
    let currentPriceList = 0;

    if (priceBlock && nextBlock) {
        const priceLists = priceBlock.querySelectorAll(`.price__list`);

        if (priceLists.length > 1 && window.screen.width >= 1200) // desktop only
        {
            const setVisiblePriceList = (idx) => {
                if (!priceLists[idx].classList.contains(`price__list--visible`))
                {
                    priceLists[currentPriceList].classList.remove(`price__list--visible`);
                    priceLists[idx].classList.add(`price__list--visible`);
                }
                currentPriceList = idx;
            }

            window.addEventListener(`scroll`, (evt) => {
                const elementBoundary = priceBlock.getBoundingClientRect();
                // const mainBlockOnTop = (elementBoundary.top - (elementBoundary.height > window.innerHeight ? 0 : 30)) <= 0;
                const mainBlockOnTop = elementBoundary.top <= 0;

                if (mainBlockOnTop)
                {
                    setVisiblePriceList(1);
                }

                if (!mainBlockOnTop)
                {
                    setVisiblePriceList(0);
                }
            });
        }
    }

    // Scroll to Price block
    const buyButtons = document.querySelectorAll(`.js-scroll-to-price`);

    if (priceBlock)
    {
        buyButtons.forEach((item) => {
            item.addEventListener(`click`, (evt) => {
                evt.preventDefault();
                let priceBox = priceBlock.getBoundingClientRect();
                window.scrollTo(0, priceBox.top + window.pageYOffset);
            });
        });
    }
})();